const NS = 'MACHINE/';

export const GET_ERROR = `${NS}GET_ERROR`;
export const GET_ALL_MACHINES = `${NS}GET_ALL`;
export const GET_ALL_MACHINES_SUCCESS = `${NS}GET_ALL_SUCCESS`;
export const GET_ALL_LOADERS = `${NS}GET_ALL_LOADERS`;
export const GET_ALL_LOADERS_SUCCESS = `${NS}GET_ALL_LOADERS_SUCCESS`;
export const GET_ALL_DUMPERS = `${NS}GET_ALL_DUMPERS`;
export const GET_ALL_DUMPERS_SUCCESS = `${NS}GET_ALL_DUMPERS_SUCCESS`;
